import { defineStore } from 'pinia';
export const useRouterCacheStore = defineStore('router-cache', {
    state: () => {
        return {
            current: null,
            keepAliveStack: [],
        }
    },
    actions: {
        update: function(stack) {
            this.keepAliveStack = stack.slice();
        },
        enter(stack) {
            
        },
        reset(stack) {
            
        },
        leave(stack) {
      
        }
    }
})